module.exports = __webpack_public_path__ + "img/37.95917433.jpg";